import { render, staticRenderFns } from "./AddColumnMenu.vue?vue&type=template&id=cd718b4a&"
import script from "./AddColumnMenu.vue?vue&type=script&lang=js&"
export * from "./AddColumnMenu.vue?vue&type=script&lang=js&"
import style0 from "./AddColumnMenu.vue?vue&type=style&index=0&id=cd718b4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports